import usePreformatifDiagnosticEditor from "@/hooks/usePreformatifDiagnosticEditor";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";
import { Button } from "react-bootstrap";

type Editor = ReturnType<typeof usePreformatifDiagnosticEditor>;

/** Export PDF, brouillon et finalisation, communs à la modale et à la page. */
const PreformatifDiagnosticActions: FC<{ editor: Editor }> = ({ editor }) => (
  <>
    <Button
      variant="outline-secondary"
      disabled={editor.dirty || editor.exporting}
      title={
        editor.dirty
          ? "Enregistrez vos modifications avant d’exporter"
          : undefined
      }
      onClick={editor.downloadPdf}
    >
      <FontAwesomeIcon icon={faFilePdf} className="me-1" />
      {editor.exporting ? "Génération…" : "Exporter le PDF"}
    </Button>
    <Button
      variant="outline-primary"
      disabled={editor.busy}
      onClick={editor.saveDraft}
    >
      Enregistrer le brouillon
    </Button>
    <Button variant="primary" disabled={editor.busy} onClick={editor.finalize}>
      Finaliser
    </Button>
  </>
);

export default PreformatifDiagnosticActions;
